import { Role } from '@kanbu/schema/enums';
import { useLingui } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';

import { FormPage } from '@/components/page/FormPage';
import { PlanManagementView } from '@/features/organizations/plan-management/PlanManagementView';
import { trpc } from '@/services/trpc';

export const Route = createFileRoute(
  '/_baseLayout/organizations/$organizationId/plan-management/',
)({
  component: OrganizationPlanManagementPage,
  beforeLoad: async ({ context: { accessGuard } }) =>
    accessGuard([Role.SuperAdmin]),
  loader: async ({ context: { trpcUtils }, params: { organizationId } }) =>
    trpcUtils.organizations.findOne.ensureData({ id: organizationId }),
});

export function OrganizationPlanManagementPage() {
  const { organizationId } = Route.useParams();
  const { t } = useLingui();

  const [organizationData] = trpc.organizations.findOne.useSuspenseQuery({
    id: organizationId,
  });

  return (
    <FormPage
      title={`${t`Plan management`} — ${organizationData.name}`}
      breadcrumbs={[
        { label: t`Organizations`, to: '/organizations' },
        {
          label: organizationData.name,
          to: '/organizations/$organizationId/edit',
          params: { organizationId },
        },
        {
          label: t`Plan management`,
          to: '/organizations/$organizationId/plan-management',
          params: { organizationId },
        },
      ]}
    >
      <PlanManagementView
        organizationId={organizationId}
        capabilities={{
          canLinkStripe: true,
          canManageInvoices: true,
          canForceCancel: true,
        }}
      />
    </FormPage>
  );
}
